import React, { useState, useEffect } from "react";
import { Card, Modal, Form, Button } from '@themesberg/react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { agregarRolAction, cerrarModalAgregarAction } from '../../actions/rolesActions';

export default (props) => {
    const dispatch = useDispatch();
    
    const { showModalAgregar } = useSelector(state => state.roles);

    const [ rolAgregar, guardarRol] = useState({
        'nombre': '',
        'descripcion': ''
    })

    const submitAgregarRol = e => {
        e.preventDefault();
        dispatch( agregarRolAction(rolAgregar) );
    }

    const handleClose = () => {
        dispatch( cerrarModalAgregarAction() );
    }

    const onChangeForm = (e) => {
        guardarRol({
            ...rolAgregar,
            [e.target.name] : e.target.value
        })
    }

    return (
        <Modal as={Modal.Dialog} centered show={showModalAgregar} onHide={handleClose}>
            <Modal.Header>
                <Modal.Title className="h6">Agregar rol</Modal.Title>
                <Button variant="close" aria-label="Close" onClick={handleClose} />
            </Modal.Header>
            <Form onSubmit={submitAgregarRol}>
            <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Label>Nombre</Form.Label>
                        <Form.Control type="text" name="nombre" placeholder="Nombre del rol" 
                            value={rolAgregar.nombre} onChange={onChangeForm} />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Descripción del rol</Form.Label>
                        <Form.Control type="text" name="descripcion" placeholder="Descripción del rol" 
                            value={rolAgregar.descripcion} onChange={onChangeForm} />
                    </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="link" className="text-gray ms-auto" onClick={handleClose}>
                    Cerrar
                </Button>
                <Button type="submit" variant="secondary">
                    Agregar
                </Button>
            </Modal.Footer>
            </Form>
        </Modal>
    );
}